import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile, rationCardCheckService } from "../../../Services/ApiTestService/aadharTestService";
import { useService } from "../../../context/ServiceContext";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import Loader from "../../../Loader";
import {FaIdCard, FaLink,
    FaCheckCircle, FaExclamationTriangle, FaUserSecret,
    FaRegAddressCard, FaUsers,
    FaPrint,
    FaCopy
} from "react-icons/fa";
import { rationCardData } from "../Data";
import { handlePrint } from "../../../utils";

const RationCardTest = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [rationData, setRationData] = useState(null);
    const [errors, setErrors] = useState({ message: "", type: "error" });
    const [profileData, setProfileData] = useState({});
    const [rationNumber, setRationNumber] = useState('');
    const { serviceName } = useService();

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);
    async function handleSubmit() {
        try {
            setErrors({ message: "", type: "" });
            if (rationNumber === "") {
                setErrors({ message: "Ration number is required", type: "error" });
                return;
            }
            let payload = {

                api_id: profileData?.user_id,
                api_key: profileData?.api_key,
                token_id: profileData?.token_id,
                ration_card_number: rationNumber
            }
            setIsLoading(true);
            let response = await rationCardCheckService({ payload: payload });
            if (response.status.code === 200) {
                setRationData(response.data);
                setRationNumber('');
                showSuccessToast(response.message);
                setIsLoading(false);
            } else {
                setIsLoading(false);
               showErrorToast(response.message || response.data.message || response.error.message || "Something went wrong.");
            }


        } catch (error) {
            setIsLoading(false);
            showErrorToast('something went wrong while error', error);
        }
    }



    const renderCompanyCard = () => {

        return (
            <div id="companyCinCard" className="relative bg-white/90 backdrop-blur-xl border border-blue-300 p-8 rounded-3xl shadow-xl max-w-3xl mx-auto transition-all duration-300 hover:shadow-3xl hover:scale-[1.02]">


                <div className="absolute top-4 right-4 w-10 h-6 bg-blue-700 flex justify-center items-center text-white rounded shadow-inner" id="hideData"><FaPrint onClick={() => handlePrint("companyCinCard", "hideData")} /></div>


                <div className="mb-6 flex items-center gap-4">
                    <FaIdCard className="text-blue-700 text-3xl" />
                    <h5 className="text-2xl font-bold text-blue-900">
                        {rationData?.id_number || "Client ID Not Available"}
                    </h5>
                </div>


                <div className="text-gray-800 text-base space-y-4">
                    <p className="flex items-center gap-2">
                        <FaIdCard className="text-indigo-500" />
                        <strong>ID Number:</strong> {rationData?.id_number || "N/A"}
                    </p>
                    <p className="flex items-center gap-2">
                        <FaLink className="text-blue-600" />
                        <strong>Portal:</strong> {rationData?.state_portal} ({rationData?.state_name}, {rationData?.district_name})
                    </p>
                    <p className="flex items-center gap-2">
                        <FaRegAddressCard className="text-purple-600" />
                        <strong>FPS ID:</strong> {rationData?.fps_id || "N/A"}
                    </p>
                    <p className="flex items-center gap-2">
                        <FaCheckCircle className="text-green-600" />
                        <strong>Scheme:</strong> {rationData?.scheme_name || "N/A"}
                    </p>
                    <p className="flex items-center gap-2">
                        <FaExclamationTriangle className="text-yellow-600" />
                        <strong>Duplicate UID:</strong> {rationData?.dup_uid_status || "N/A"}
                    </p>
                </div>


                <div className="mt-8">
                    <div className="flex items-center gap-2 mb-4">
                        <FaUsers className="text-pink-600 text-lg" />
                        <h3 className="text-xl font-semibold text-gray-800">Household Members</h3>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {rationData?.member_details_list?.map((member, index) => (
                            <div
                                key={index}
                                className="bg-blue-50 border border-blue-200 hover:scale-105  rounded-xl p-4 shadow-sm"
                            >
                                <p><strong>Name:</strong> {member?.member_name}</p>
                                <p><strong>Relation:</strong> {member?.relationship_name}</p>
                                <p><strong>UID Status:</strong> {member?.uid_status ? "Linked" : "Not Linked"}</p>
                                <p><strong>Masked Aadhaar:</strong> {member?.masked_aadhaar || "Not Available"}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }

    return (
        <>
            <Seo />
            {isLoading && <Loader />}
            <Header heading={serviceName} />
                  
                  <div className="col-span-2 md:col-span-6 flex justify-end">
              <Link
                to="/TestMaster"
                className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
              >
                <span>Go Back</span>
                <IoArrowBackCircleOutline size={24} />
              </Link>
            </div>
            <div className="flex items-center gap-2 py-5 bg-gray-100 shadow-sm">
                <div>
                    <InputWithLabel type={'text'} label={"Ration Card Number"} placeholder={"Enter ration card number."} value={rationNumber} onChange={(e) => setRationNumber(e.target.value)} />
                    <span className={`${errors.type === "error" ? 'text-red-800' : 'text-green-500'} `}>{errors?.message}</span>
                </div>
                <div className="mt-5">
                    <Button text={'Verify'} type={'text'} onClick={handleSubmit} />
                </div>
            </div>


            {rationData && (
                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>{renderCompanyCard()}</div>
                    <pre className="bg-black relative text-green-500 p-4 rounded text-sm overflow-auto max-h-[600px]">
                        <FaCopy className="absolute top-2 cursor-pointer right-2  bg-white p-1 rounded-md font-bold text-2xl" onClick={()=>handleCopyText(rationData)} />
                        {JSON.stringify(rationData, null, 2)}
                    </pre>
                </div>
            )}
        </>
    );
};
const RationCardInstructions = () => {
    return (
        <div className="max-w-5xl mx-auto p-5 bg-white shadow-lg rounded-lg border border-gray-200">
            <h1 className="text-xl font-semibold mb-3 text-red-600 border-b pb-2">Ration Card Verify Instructions</h1>
            <ol className="list-decimal pl-5 space-y-3 text-gray-700 text-sm">
                
               
                <li>
                    <strong>Important:</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>Use only your first name (first four letters)</li>
                        <li>If name has fewer than 4 letters, use the full name</li>
                        <li>No spaces or symbols in the password</li>
                    </ul>
                </li>
                <li>
                    <strong>Having Issues?</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>Double-check name and year format</li>
                        <li>Ensure your PDF viewer supports secure files</li>
                    </ul>
                </li>
                <li>
                    <strong>Need Help?</strong> Reach out to support or visit the official Aadhaar help center.
                </li>
            </ol>
        </div>
    );
};
export default RationCardTest;
